export interface Video {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  views: number;
  score: number;
  description: string;
  tags: string[];
  publishDate: string;
  isHot: boolean;
  isNew: boolean;
  episodes?: number;
}

export const videos: Video[] = [
  {
    id: "vid-1",
    title: "流浪地球3",
    category: "电影",
    categorySlug: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20astronauts%20and%20giant%20planet%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20teal%20tones%2C%20movie%20poster%20style%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-01&orientation=landscape",
    duration: "02:28:15",
    views: 12850000,
    score: 9.2,
    description: "太阳急速老化，持续膨胀，一百年后将吞没地球。人类在地球表面建造出巨大的行星发动机，推动地球逃离太阳系，去寻找新的家园。在这场跨越2500年的漫长旅途中，人类将面临前所未有的考验与抉择。",
    tags: ["科幻", "灾难", "冒险", "IMAX"],
    publishDate: "2026-07-15",
    isHot: true,
    isNew: true,
  },
  {
    id: "vid-2",
    title: "长安十二时辰",
    category: "电视剧",
    categorySlug: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20poster%20with%20warriors%20in%20traditional%20armor%2C%20warm%20golden%20tones%2C%20epic%20cinematic%20style%2C%20historical%20atmosphere%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-02&orientation=landscape",
    duration: "00:45:00",
    views: 8650000,
    score: 9.5,
    description: "唐朝天宝三年，上元节前夕，长安城混入可疑人员。身陷囹圄的张小敬临危受命，与少年天才李必携手在十二时辰内破除隐患，拯救长安城于危难之中。",
    tags: ["古装", "悬疑", "历史", "精品剧"],
    publishDate: "2026-06-20",
    isHot: true,
    isNew: false,
    episodes: 48,
  },
  {
    id: "vid-3",
    title: "极限挑战 第十季",
    category: "综艺",
    categorySlug: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Variety%20show%20poster%20with%20group%20of%20celebrities%20having%20fun%20outdoors%2C%20bright%20warm%20colors%2C%20energetic%20atmosphere%2C%20entertainment%20style%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-03&orientation=landscape",
    duration: "01:30:00",
    views: 10500000,
    score: 8.8,
    description: "王牌综艺强势回归！全新阵容带来更加精彩的挑战任务，爆笑不断，感动常在。每一期都是一场智力与体力的极限较量。",
    tags: ["真人秀", "搞笑", "挑战", "热门综艺"],
    publishDate: "2026-07-01",
    isHot: true,
    isNew: true,
  },
  {
    id: "vid-4",
    title: "鬼灭之刃 无限城篇",
    category: "动漫",
    categorySlug: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20poster%20with%20warrior%20holding%20sword%20in%20dramatic%20pose%2C%20dark%20atmosphere%20with%20warm%20accent%20colors%2C%20Japanese%20animation%20style%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-04&orientation=landscape",
    duration: "00:24:00",
    views: 15600000,
    score: 9.7,
    description: "炭治郎一行人终于抵达鬼舞辻无惨所在的无限城。在这里，他们将面对最强的上弦之鬼，展开一场关乎人类命运的最终决战。",
    tags: ["热血", "战斗", "日漫", "剧场版"],
    publishDate: "2026-07-28",
    isHot: true,
    isNew: true,
  },
  {
    id: "vid-5",
    title: "地球脉动 第三季",
    category: "纪录片",
    categorySlug: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20landscape%20and%20wildlife%2C%20earth%20tones%2C%20breathtaking%20scenery%2C%20BBC%20style%20nature%20photography%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-05&orientation=landscape",
    duration: "00:58:00",
    views: 7200000,
    score: 9.8,
    description: "BBC自然纪录片巅峰之作回归！历时4年，横跨6大洲43个国家，用最先进的拍摄技术记录地球上最壮丽的自然奇观和野生动物故事。",
    tags: ["自然", "BBC", "4K", "精品"],
    publishDate: "2026-05-10",
    isHot: false,
    isNew: false,
  },
  {
    id: "vid-6",
    title: "NBA总决赛 2026",
    category: "体育",
    categorySlug: "tiyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Basketball%20game%20intense%20moment%20with%20players%20in%20action%2C%20arena%20atmosphere%2C%20dramatic%20sports%20photography%2C%20warm%20arena%20lighting%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-06&orientation=landscape",
    duration: "02:15:00",
    views: 9800000,
    score: 9.0,
    description: "2026年NBA总决赛全程回放！巅峰对决，精彩绝伦。见证冠军的诞生，感受篮球运动的无限魅力。",
    tags: ["篮球", "NBA", "总决赛", "体育"],
    publishDate: "2026-06-25",
    isHot: true,
    isNew: false,
  },
  {
    id: "vid-7",
    title: "华语金曲榜 年度盛典",
    category: "音乐",
    categorySlug: "yinyue",
    thumbnail: "https://readdy.ai/api/search-image?query=Music%20awards%20ceremony%20poster%20with%20stage%20lights%20and%20performer%20silhouette%2C%20glamorous%20atmosphere%2C%20concert%20style%20photography%2C%20warm%20golden%20stage%20lighting%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-07&orientation=landscape",
    duration: "03:00:00",
    views: 5600000,
    score: 8.5,
    description: "年度华语音乐盛典，汇聚华语乐坛顶级歌手。精彩演出、颁奖典礼全程记录，不容错过的音乐盛宴。",
    tags: ["音乐", "颁奖", "演唱会", "华语"],
    publishDate: "2026-04-18",
    isHot: false,
    isNew: false,
  },
  {
    id: "vid-8",
    title: "黑神话：悟空 全剧情",
    category: "游戏",
    categorySlug: "youxi",
    thumbnail: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20game%20poster%20with%20monkey%20warrior%20character%2C%20Chinese%20mythology%20style%2C%20dramatic%20lighting%2C%20epic%20game%20art%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-08&orientation=landscape",
    duration: "36:00:00",
    views: 20300000,
    score: 9.6,
    description: "国产3A大作《黑神话：悟空》全剧情通关！天命人踏上西游之路，经历九九八十一难。精美画面，震撼战斗，国产游戏的里程碑之作。",
    tags: ["游戏", "动作", "神话", "国产"],
    publishDate: "2026-07-20",
    isHot: true,
    isNew: true,
  },
  {
    id: "vid-9",
    title: "无名之辈2",
    category: "电影",
    categorySlug: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20ordinary%20people%20in%20urban%20setting%2C%20warm%20lighting%2C%20realistic%20style%2C%20slice%20of%20life%20aesthetic%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-09&orientation=landscape",
    duration: "01:52:00",
    views: 6500000,
    score: 8.7,
    description: "一群小人物在大城市中的悲欢离合。他们虽然平凡，却有着不平凡的梦想。笑中带泪，温情治愈，献给每一个努力生活的你。",
    tags: ["喜剧", "剧情", "温暖", "国产"],
    publishDate: "2026-03-08",
    isHot: false,
    isNew: false,
  },
  {
    id: "vid-10",
    title: "庆余年 第三季",
    category: "电视剧",
    categorySlug: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20scholar%20in%20ancient%20robe%2C%20mysterious%20atmosphere%2C%20warm%20golden%20tones%2C%20epic%20drama%20style%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-10&orientation=landscape",
    duration: "00:50:00",
    views: 18200000,
    score: 9.4,
    description: "范闲从北齐归来，却发现京都风云再起。权谋与江湖交错，爱恨情仇交织，一场更大的棋局正在展开。且看范闲如何破局重生。",
    tags: ["古装", "权谋", "玄幻", "热门剧"],
    publishDate: "2026-07-10",
    isHot: true,
    isNew: true,
    episodes: 36,
  },
  {
    id: "vid-11",
    title: "进击的巨人 最终季 后篇",
    category: "动漫",
    categorySlug: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Dark%20anime%20poster%20with%20giant%20titan%20and%20soldiers%2C%20apocalyptic%20atmosphere%2C%20dramatic%20action%20scene%2C%20Japanese%20animation%20style%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-11&orientation=landscape",
    duration: "01:25:00",
    views: 19500000,
    score: 9.8,
    description: "地鸣发动，世界陷入绝望。艾伦与曾经的伙伴们走上截然不同的道路，最终的决战即将到来。自由与生命的终极命题，将在这里得到回答。",
    tags: ["热血", "战斗", "日漫", "完结篇"],
    publishDate: "2026-07-05",
    isHot: true,
    isNew: false,
  },
  {
    id: "vid-12",
    title: "舌尖上的中国 第五季",
    category: "纪录片",
    categorySlug: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20delicious%20traditional%20dishes%2C%20warm%20kitchen%20atmosphere%2C%20steaming%20food%20photography%2C%20authentic%20Chinese%20cuisine%20style%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-12&orientation=landscape",
    duration: "00:50:00",
    views: 8900000,
    score: 9.3,
    description: "寻味中国，品味人生。本季将带领观众深入中国各地，探寻那些鲜为人知的民间美食，讲述食物背后的人间烟火故事。",
    tags: ["美食", "文化", "人文", "国产"],
    publishDate: "2026-06-01",
    isHot: false,
    isNew: false,
  },
];